import moment from "moment";
import { Card } from "src/components";
import CrmService from "@/services/CrmService.js";
import {
  fetchAddress,
  fetchCnpj,
  fetchRegister,
} from "@/services/Crm/CrmCidade.js";
import { fetchPlans } from "@/services/Crm/CrmPlans.js";
import { fetchSellers } from "@/services/Crm/CrmSellers.js";
import {
  verifyClient,
  verifyContract,
  verifyEntries,
  genInvoice,
  verifyRegister,
} from "@/services/Crm/CrmCliente.js";
import { constants, getEnviroment } from "@/shared";
import * as io from "socket.io-client";
import "vue-search-select/dist/VueSearchSelect.css";
import { f, ModelSelect } from "vue-search-select";

import { v4 as uuidv4 } from "uuid";

const MESSAGE_REPORT = {
  CLIENT_SUCCESS: "client-creation-success",
  CLIENT_ERROR: "client-creation-error",
  CONTRACT_SUCCESS: "contract-creation-success",
  CONTRACT_ERROR: "contract-creation-error",
  BILLING_SUCCESS: "billing-success",
  BILLING_ERROR: "billing-error",
};

const DISCOUNT_TYPES = {
  PERCENTAGE: "percentage",
  FLAT: "flat",
};

const DISCOUNT_TYPES_LABELS = {
  [DISCOUNT_TYPES.PERCENTAGE]: "Porcentagem",
  [DISCOUNT_TYPES.FLAT]: "Valor Fixo",
};

const COOKIE_MENAGEMENT = {
  INVALID_DISCOUNT_MODAL: {
    name: "invalid-discount-modal",
    value: "true",
    expires: new Date(new Date().setMonth(new Date().getMonth() + 1)),
  },
};

export default {
  components: {
    Card,
    ModelSelect,
  },
  data() {
    return {
      discountTypes: Object.values(DISCOUNT_TYPES),
      isDiscountApplied: false,
      discountAllCycles: false,
      discount: {
        value: null,
        type: null,
        cycles: 1,
      },
      discountOptions: [
        {
          value: DISCOUNT_TYPES.FLAT,
          text: DISCOUNT_TYPES_LABELS[DISCOUNT_TYPES.FLAT],
        },
        {
          value: DISCOUNT_TYPES.PERCENTAGE,
          text: DISCOUNT_TYPES_LABELS[DISCOUNT_TYPES.PERCENTAGE],
        },
      ],
      printDiscountString: null,
      wss: null,
      nCodCtr: null,
      isPaymentMethodInvoice: true,
      integrationCode: null,
      socket_url: getEnviroment({
        prod: "https://socket-prod.yooga.com.br",
        develop: "https://socket-hom.yooga.com.br",
        test: "https://socket-hom.yooga.com.br",
      }),
      payment_url: getEnviroment({
        prod: "pagamento.yooga.com.br",
        develop: "beta.pagamento.yooga.com.br",
        test: "localhost:4200",
      }),
      isSwalClosed: true,
      attempts: 0,
      maxAttempts: 10,
      isValidCep: "",
      cnpj_class: "",
      loading: false,
      telefone: "",
      localidade: "",
      plans: [],
      extraPlans: [],
      selected_plan: null,
      selected_extraPlans: null,
      sellers: [],
      selected_seller: null,
      tipoFatElement: "",
      diasVencimentoBoleto: 5,
      environment: constants.dom.development,
      cpf_cnpj: "",
      documents: [],
      tradeName: "",
      state: {
        payment_method: "invoice",
        isClientAlreadyRegistered: false,
        client: {
          codigo_cliente_omie: 12345,
          codigo_cliente_integracao: "",
          razao_social: "",
          cnpj_cpf: "",
          nome_fantasia: "",
          telefone1_ddd: "",
          telefone1_numero: "",
          contato: "",
          endereco: "",
          endereco_numero: "",
          bairro: "",
          complemento: "",
          estado: "",
          cidade: "",
          cep: "",
          codigo_pais: "1058",
          email: "",
          inscricao_municipal: "",
          inscricao_estadual: "",
          inscricao_suframa: "",
          pessoa_fisica: "S",
          optante_simples_nacional: "N",
          tipo_atividade: "8", // Tipo: Associação.
          tags: [{ tag: "Cliente" }],
          inativo: "S",
        },
        contract: {
          cabecalho: {
            cCodSit: "10", // cCodSit - Status do Contrato || 00 - Em Elaboração ; 10 - Ativo ; 90 - Suspenso ; 99 - Cancelado
            cNumCtr: `${moment().format("YYYY")}/${moment().format(
              "MM"
            )}-${Math.floor(Math.random() * 1000)}`,
            cTipoFat: "01",
            dVigFinal: moment().add("10", "y").format("DD/MM/YYYY"),
            dVigInicial: moment().format("DD/MM/YYYY"),
            nDiaFat: parseInt(moment().format("DD")),
          },
          infAdic: {
            cCidPrestServ: "", // TODO: Verificar se é fixo a cidade
            cCodART: "",
            cCodCateg: "",
            cCodObra: "",
            cContato: "",
            cDadosAdicNF: "",
            nCodProj: 0,
            nCodVend: 0,
          },
          vencTextos: {
            nDias: 5,
          },
          plan: [],
          email: "",
          isPaymentMethodInvoice: true,
        },
      },
      style: `<style scoped>#loading {min-height: auto !important;display: inline-block;width: 100px;height: 100px;border: 3px solid #137b85;border-radius: 50%;border-top-color: #6eafb5;animation: spin 1s ease-in-out infinite;-webkit-animation: spin 1s ease-in-out infinite;}@keyframes spin {  to {-webkit-transform: rotate(360deg);}}@-webkit-keyframes spin {to {-webkit-transform: rotate(360deg);}}</style>`,
    };
  },
  methods: {
    async onSubmit() {
      if (!(await this.isFormValidated())) return true;

      const isSummaryApproved =
        this.isDiscountApplied && !!this.discount.value && !!this.discount.type
          ? await this.showDiscountSummaryModal()
          : true;

      if (!isSummaryApproved) return (this.loading = false);

      this.state.contract.plan = [];

      this.state.contract.plan.push(this.selected_plan);
      this.handleExtraPlans();
      this.state.contract.email = this.state.client.email;
      this.state.contract.cabecalho.nDiaFat =
        +this.state.contract.cabecalho.nDiaFat;
      this.state.contract.infAdic.cCidPrestServ = `${this.localidade} (${this.state.client.estado})`;
      this.state.contract.infAdic.cCodCateg =
        this.selected_plan.cabecalho.cCodCateg;
      this.isDiscountApplied ? this.handleDiscount() : null;

      this.loading = true;

      this.isPaymentMethodInvoice = this.state.payment_method === "invoice";
      this.state.contract.isPaymentMethodInvoice = this.isPaymentMethodInvoice;
      this.verifyOmieRegister({
        client: true,
        contract: true,
        invoice: this.isPaymentMethodInvoice,
      });

      CrmService.create(this.state)
        .then((res) => {
          console.log(res);
          this.wss.on("report", (data) => {
            this.reportWatcher(JSON.parse(data));
          });
        })
        .catch((err) => {
          this.$swal.close();
          console.error(err);
          this.registerError(
            "client",
            "Ocorreu um erro ao criar o cliente na Omie. Tente novamente mais tarde."
          );
          this.loading = false;
        });
    },
    reportWatcher({ to, outcast, message }) {
      const integração_code = this.state.client.codigo_cliente_integracao;

      if (!(to === integração_code) && !(String(to) === String(this.nCodCtr)))
        return console.log(
          "%cMessage not destined for this client",
          "color: #ff0000; font: bold"
        );

      if (outcast === MESSAGE_REPORT.CLIENT_SUCCESS) {
        document.querySelector("#cliente").innerHTML = `✅ Cliente criado!`;
      } else if (outcast === MESSAGE_REPORT.CLIENT_ERROR) {
        document.querySelector(
          "#cliente"
        ).innerHTML = `❌ Erro ao criar cliente`;
        // this.registerError('client', 'Ocorreu um erro ao buscar o cliente no Omie. Tente novamente mais tarde.')
        this.loading = false;
      }

      if (outcast === MESSAGE_REPORT.CONTRACT_SUCCESS) {
        document.querySelector("#contrato").innerHTML = `✅ Contrato criado!`;
        if (!this.isPaymentMethodInvoice) this.registerSuccess(false);
        this.nCodCtr = !!message.nCodCtr ? message.nCodCtr : null;
      } else if (outcast === MESSAGE_REPORT.CONTRACT_ERROR) {
        document.querySelector(
          "#contrato"
        ).innerHTML = `❌ Erro ao criar contrato`;
        // this.registerError('contract', 'Ocorreu um erro ao buscar o contrato no Omie. Tente novamente mais tarde.')
        this.loading = false;
      }

      if (outcast === MESSAGE_REPORT.BILLING_SUCCESS) {
        document.querySelector(
          "#contratofat"
        ).innerHTML = `✅ Contrato Faturado!`;
        setTimeout(() => {
          this.startWatchingBill();
        }, 750);
      } else if (outcast === MESSAGE_REPORT.BILLING_ERROR) {
        document.querySelector(
          "#contratofat"
        ).innerHTML = `❌ Erro ao criar fatura`;
        // this.registerError('contratofat', 'Ocorreu um erro ao buscar a fatura no Omie. Tente novamente mais tarde.')
        this.loading = false;
      }
    },
    startWatchingBill() {
      const cnpj_cpf = this.state.client.cnpj_cpf.replace(/\.|-|\//g, "");

      if (this.isSwalClosed)
        this.$swal.fire({
          showConfirmButton: false,
          allowOutsideClick: true,
          title: "Aguarde...",
          html: `
            ${this.style}
            Estamos gerando o boleto...
            <br>
            <br>
            <div id="loading"></div>
          `,
        });

      this.isSwalClosed = false;
      let timeout = setTimeout(async () => {
        await CrmService.invoice_fetching(cnpj_cpf)
          .then((res) => {
            const { data } = res;
            if (
              data.data.length > 0 ||
              (!!data.data.cLinkBoleto && data.data.cLinkBoleto !== "")
            ) {
              this.confirmRegisterSuccess(data.data.cLinkBoleto);
              clearTimeout(timeout);
            } else {
              console.error(data);
              console.log(`${this.maxAttempts - this.attempts} attempts left`);
              this.attempts++;
              if (this.attempts === this.maxAttempts) {
                clearTimeout(timeout);
                this.registerError(
                  "boleto",
                  "Ocorreu um erro ao gerar o boleto no Omie. Tente novamente mais tarde."
                );
              } else {
                this.startWatchingBill();
              }
            }
          })
          .catch((err) => {
            this.attempts++;
            console.error(err);
            console.log(`${this.maxAttempts - this.attempts} attempts left`);
            if (this.attempts === this.maxAttempts) {
              clearTimeout(timeout);
              this.registerError(
                "boleto",
                "Ocorreu um erro ao gerar o boleto no Omie. Tente novamente mais tarde."
              );
            } else {
              this.startWatchingBill();
            }
          });
      }, 2000);
    },
    registerError(type, message) {
      this.loading = false;
      this.$swal.close();
      this.$swal.fire({
        title: `Erro ao ${type === "contratofat" ? "faturar" : "criar"} ${
          type === "contratofat" ? "contrato" : type
        }`,
        text: message,
        type: "error",
      });
    },
    registerSuccess(isToReloadAfter = true) {
      this.loading = false;
      this.$swal.close();
      this.$swal.fire({
        allowOutsideClick: true,
        showConfirmButton: false,
        title: "Contrato criado com sucesso!",
        text: "O contrato foi criado com sucesso no Omie e no CRM.",
        type: "success",
      });
      setTimeout(() => {
        this.$swal.close();

        isToReloadAfter
          ? setTimeout(() => {
              window.location.reload();
            }, 500)
          : this.showCreditCardLink();
      }, 3500);
    },
    showCreditCardLink() {
      const link = `${this.payment_url}/contratacao/${this.integrationCode}`;

      this.$swal.fire({
        title: "Link de pagamento.",
        showConfirmButton: false,
        html: `
            <div class="swal-padding">
            <div class="input-group mb-3">
              <input disabled value="${link}" type="text" class="form-control swal-input-custom" >
              <div class="input-group-append">
                <button  onclick="navigator.clipboard.writeText('${link}')" class="btn btn-outline-secondary swal-button-custom" type="button">Copiar!</button>
              </div>
            </div>
          `,
        customClass: "swal-wide",
        onClose: () => {
          window.location.reload();
        },
      });
    },
    confirmRegisterSuccess(data) {
      this.$swal
        .fire({
          type: "success",
          title: `Cliente: ${this.state.client.razao_social}, cadastrado com sucesso!`,
          text: "Deseja gerar o boleto?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, gerar!",
        })
        .then((res) => {
          if (res.value) {
            const popup = window.open(
              data,
              "pagina",
              "width=1200px, height=800px,  scrollbars=no"
            );
            popup.focus();
            const closedWindow = setInterval(() => {
              console.log(popup.closed);
              if (popup.closed) this.registerSuccess();
              if (popup.closed) clearInterval(closedWindow);
            }, 1000);

            setTimeout(() => {
              clearInterval(closedWindow);
            }, 30000);

            // setTimeout(() => { popup.close() }, 3500)
          }
        });
    },
    async fetchAddress() {
      console.log(this.state.client.cep);
      const { data } = await fetchAddress(this.state.client.cep);
      console.log(data);

      if (data.erro && data.erro === "true") return this.cepMessageError();

      this.localidade = data.localidade ? data.localidade : "";
      this.state.client.cidade = data.ibge ? +data.ibge : "";
      this.state.client.estado = data.uf ? data.uf : "";
      this.state.client.bairro = data.bairro ? data.bairro : "";
      this.state.client.endereco = data.logradouro ? data.logradouro : "";
    },
    splitTel() {
      this.telefone = this.telefone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "");
      this.state.client.telefone1_ddd = this.telefone.substring(0, 2);
      this.state.client.telefone1_numero = this.telefone.substring(2);
    },
    cepMessageError() {
      this.isValidCep = "is-invalid";
      this.$swal.fire({
        type: "error",
        title: "CEP não encontrado!",
        html: `Verifique o CEP digitado e tente novamente.
          O erro <strong style='font-size: 22px;' >Não impede o cadastro!</strong>`,
      });

      setTimeout(() => {
        this.isValidCep = "";
      }, 3000);
    },
    async isClientExistent() {
      const cpf_cnpj = this.state.client.cnpj_cpf;

      if (!(cpf_cnpj && cpf_cnpj != "")) return;

      const { data } = await verifyClient(cpf_cnpj.replace(/\/|-|\./g, ""));

      if (data.status === 409) {
        this.state.isClientAlreadyRegistered = true;
        return this.clientAlreadyExists(data, cpf_cnpj);
      } else {
        this.state.isClientAlreadyRegistered = false;
      }
      if (this.isSwalClosed) {
        this.$swal.fire({
          showConfirmButton: false,
          allowOutsideClick: true,
          title: "Aguarde...",
          html: `
            ${this.style}
            Buscando informações...
            <br>
            <br>
            <div id="loading"></div>
          `,
        });
      }
      if (cpf_cnpj.length > 12)
        this.fetchCnpja().catch((err) => {
          this.fetchReceitaFederal().catch((err) => {
            return this.cnpjMessageError();
          });
        });

      this.cnpj_class = "is-valid";
    },
    async fetchCnpja() {
      const cpf_cnpj = this.state.client.cnpj_cpf.replace(/\/|-|\./g, "");
      const { data } = await fetchCnpj(cpf_cnpj);

      this.state.client.nome_fantasia = data.alias
        ? data.alias
        : data.company.name.split(" ", 2).join(" ");
      this.state.client.razao_social = data.company
        ? data.company.name.substring(0, 59)
        : "";
      // this.state.client.email = data.emails.length > 0 ? data.emails[0].address : ''
      this.state.client.email = getEnviroment({
        prod: data.emails.length > 0 ? data.emails[0].address : "",
        develop: "invalid@gmail.com",
        test: "invalid@gmail.com",
      });
      this.state.client.contato =
        data.company.members.length > 0
          ? data.company.members[0].person.name
          : "";
      this.state.client.cep = data.address.zip ? data.address.zip : "";
      this.state.client.endereco = data.address.street
        ? data.address.street
        : "";
      this.state.client.endereco_numero = data.address.number
        ? data.address.number
        : "";
      this.state.client.bairro = data.address.district
        ? data.address.district
        : "";
      this.state.client.bairro = data.address.district
        ? data.address.district
        : "";
      this.localidade = data.address.city ? data.address.city : "";
      this.state.client.estado = data.address.state ? data.address.state : "";
      this.state.client.complemento = data.address.details
        ? data.address.details.substring(0, 59)
        : "";
      this.state.client.cidade = data.address.municipality
        ? +data.address.municipality
        : "";
      this.telefone = data.phones.length
        ? `${data.phones[0].area}${data.phones[0].number}`
        : "";
      this.state.client.telefone1_ddd = data.phones.length
        ? data.phones[0].area
        : "";
      this.state.client.telefone1_numero = data.phones.length
        ? data.phones[0].number
        : "";
      this.$swal.close();
    },
    async fetchReceitaFederal() {
      const cpf_cnpj = this.state.client.cnpj_cpf.replace(/\/|-|\./g, "");
      const { data } = await fetchRegister(cpf_cnpj);

      this.state.client.nome_fantasia = data.nome_fantasia;
      this.state.client.razao_social = data.razao_social
        ? data.razao_social.substring(0, 59)
        : "";
      this.state.client.email = getEnviroment({
        prod: data.email ? data.email : "",
        develop: "invalid@gmail.com",
        test: "invalid@gmail.com",
      });
      this.state.client.contato = "";
      this.state.client.cep = data.cep ? data.cep : "";
      this.state.client.endereco = data.logradouro ? data.logradouro : "";
      this.state.client.endereco_numero = data.numero ? data.numero : "";
      this.state.client.bairro = data.bairro ? data.bairro : "";
      this.localidade = data.municipio ? data.municipio : "";
      this.state.client.estado = data.uf ? data.uf : "";
      this.state.client.complemento = data.complemento
        ? data.complemento.substring(0, 59)
        : "";
      this.state.client.cidade = data.codigo_municipio_ibge
        ? +data.codigo_municipio_ibge
        : "";
      this.telefone = data.ddd_telefone_1 ? data.ddd_telefone_1 : "";
      this.state.client.telefone1_ddd = data.ddd_telefone_1
        ? data.ddd_telefone_1.substring(0, 2)
        : "";
      this.state.client.telefone1_numero = data.ddd_telefone_1
        ? data.ddd_telefone_1.substring(2)
        : "";
      this.$swal.close();
    },
    cnpjMessageError() {
      this.$swal.close();
      this.$swal({
        type: "error",
        title: "Oops...",
        html: `Não foi encontrado nenhum CNPJ na receita com as credenciais: \n ${this.state.client.cnpj_cpf}`,
      }).then((res) => {
        console.log(res);
      });
    },
    async fetchPlan() {
      const {
        data: { data },
      } = await fetchPlans();

      const plans = data.cadastros.filter((plan) =>
        plan.cabecalho.cDescricao.toLowerCase().includes("plano")
      );
      const extraPlans = data.cadastros.filter(
        (plan) => !plan.cabecalho.cDescricao.toLowerCase().includes("plano")
      );

      this.plans = plans;
      this.extraPlans = extraPlans;
    },
    async fetchSellers() {
      const {
        data: { data },
      } = await fetchSellers();
      this.sellers = data;
    },
    clientAlreadyExists(data, cpf_cnpj) {
      this.associateAlreadyExistingClient(data);

      this.cnpj_class = "is-invalid";
      this.$swal({
        type: "error",
        title: "Oops...",
        html: `foi encontrado um registro para esse cnpj! \n ${cpf_cnpj}
              <br><strong>Empresa:</strong> ${data.data.commercial_name}
              <br><strong>Contato:</strong> ${data.data.contact}
          `,
      }).then((res) => {
        console.log(res);
      });
    },
    setTipoFat(type) {
      this.state.contract.cabecalho.cTipoFat = type;
      this.tipoFatElement.setAttribute("readonly", true);
    },
    verifyOmieRegister({ client, contract, invoice }) {
      this.$swal.fire({
        html: `
          <style scoped>
            #loading {
              min-height: auto !important;
              display: inline-block;
              width: 50px;
              height: 50px;
              border: 3px solid #137b85;
              border-radius: 50%;
              border-top-color: #6eafb5;
              animation: spin 1s ease-in-out infinite;
              -webkit-animation: spin 1s ease-in-out infinite;
            }

            @keyframes spin {
              to {
                -webkit-transform: rotate(360deg);
              }
            }
            @-webkit-keyframes spin {
              to {
                -webkit-transform: rotate(360deg);
              }
            }

          </style>
          <div id="loading"></div>
          ${
            !this.state.isClientAlreadyRegistered
              ? client
                ? `<div id="cliente"> 🔍 Verificando criação de cliente...</div>`
                : ""
              : `<div id="cliente"> ✅ Cliente já existente!</div>`
          }
          ${
            contract
              ? `<div id="contrato"> 🔍 Verificando criação de contrato...</div>`
              : ""
          }
          ${
            invoice
              ? ` <div id="contratofat"> 🔍 Verificando o faturamento do contrato...</div>`
              : ""
          }
          `,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    },
    isValidInput(value, inputId) {
      let switcher = !!value && value !== undefined && value !== "";
      // console.log(`switcher is ${switcher} for the input >> ${inputId} value >> ${value}`)
      if (!switcher) {
        document.querySelector(`#${inputId}`).classList.add("is-invalid");
        setTimeout(() => {
          document.querySelector(`#${inputId}`).classList.remove("is-invalid");
        }, 3000);
      }
      return switcher;
    },
    associateAlreadyExistingClient({ data }) {
      console.log(data);

      this.state.client.nome_fantasia = data.commercial_name;
      this.state.client.razao_social = data.commercial_name;
      this.state.client.email = data.email;
      this.state.client.contato = data.contact;
      this.state.client.cep = data.cep;
      this.state.client.telefone1_ddd = data.telefone1_ddd;
      this.state.client.telefone1_numero = data.telefone1_numero;
      this.telefone = `${data.telefone1_ddd}${data.telefone1_numero}`;
      this.state.contract.cabecalho.nCodCli = data.client_id;
      this.state.client.endereco_numero = data.endereco_numero;

      if (!!data.cep && data.cep.length === 8) {
        this.fetchAddress(data.cep);
      }
    },
    async isFormValidated() {
      let validators = [
        this.isValidInput(this.state.client.razao_social, "razao_social"),
        this.isValidInput(this.state.client.cnpj_cpf, "cnpj_cpf"),
        this.isValidInput(this.state.client.nome_fantasia, "nome_fantasia"),
        this.isValidInput(this.state.client.contato, "contato"),
        this.isValidInput(this.telefone, "telefone"),
        // this.validateInput(this.state.client.telefone1_numero , 'telefone1_numero',),
        this.isValidInput(this.state.client.email, "email"),
        this.isValidInput(this.state.client.cep, "cep"),
        this.isValidInput(this.state.client.endereco, "endereco"),
        this.isValidInput(this.state.client.endereco_numero, "endereco_numero"),
        this.isValidInput(this.state.client.estado, "estado"),
        this.isValidInput(this.localidade, "cidade"),
        this.isValidInput(this.state.client.bairro, "bairro"),
        this.isValidInput(this.state.contract.infAdic.nCodVend, "nCodVend"),
        this.isValidInput(this.state.contract.cabecalho.cTipoFat, "cTipoFat"),
        this.isValidInput(
          this.state.contract.cabecalho.dVigInicial,
          "dVigInicial"
        ),
        this.isValidInput(this.state.contract.cabecalho.dVigFinal, "dVigFinal"),
        this.isValidInput(this.state.contract.cabecalho.nDiaFat, "nDiaFat"),
        this.isValidInput(this.state.payment_method, "payment_method"),
        this.isValidInput(
          typeof this.selected_plan === "object"
            ? this.selected_plan
            : !this.selected_plan.includes("Selecione")
            ? this.selected_plan
            : null,
          "plan"
        ),
      ];

      if (validators.some((item) => !item)) return false;
      else return true;
    },

    changePaymentMethod() {
      if (this.state.contract.cabecalho.cCodSit === "10") {
        this.state.payment_method = "invoice";
        this.isPaymentMethodInvoice = true;
      }
      if (this.state.contract.cabecalho.cCodSit === "00") {
        this.state.payment_method = "credit_card";
        this.isPaymentMethodInvoice = false;
      }
    },
    handleExtraPlans() {
      if (!this.state.contract.plan.length > 0) return false;

      if (!!this.selected_extraPlans && this.selected_extraPlans !== "null") {
        const firstPlanCategory =
          this.state.contract.plan[0].cabecalho.cCodCateg;
        if (!!!this.selected_extraPlans.cabecalho.cCodCateg)
          this.selected_extraPlans.cabecalho.cCodCateg = firstPlanCategory;
        this.state.contract.plan.push(this.selected_extraPlans);
      }
    },
    modalData() {
      const planPricing = this.getPlanValues();
      const discountedValue =
        this.discount.type === DISCOUNT_TYPES.FLAT
          ? planPricing - this.discount.value
          : (planPricing - planPricing * (this.discount.value / 100)).toFixed(
              2
            );

      let data = `
              <style>
                .has-discount {
                  background-color: #0080002e !important;
                  font-weight: 400;
                }
              </style>
              `;

      for (let [datas, index] of Array(12).entries()) {
        if (datas + 1 <= this.discount.cycles) {
          data += `<tr class="has-discount">
                      <td>${datas + 1}</td>
                      <td>R$${planPricing}</td>
                      <td>${
                        this.discount.type === DISCOUNT_TYPES.FLAT ? "R$" : ""
                      }${this.discount.value}${
            this.discount.type === DISCOUNT_TYPES.PERCENTAGE ? "%" : ""
          }</td>
                      <td>R$${discountedValue}</td>
                    </tr>`;
        } else {
          data += `<tr>
                      <td>${datas + 1}</td>
                      <td>R$${planPricing}</td>
                      <td>0</td>
                      <td>R$${planPricing}</td>
                    </tr>`;
        }
      }

      return data;
    },
    async showDiscountSummaryModal() {
      return await this.$swal({
        title: "Desconto aplicado",
        showCancelButton: true,
        html: `
          <style>
            .swal2-popup {
              width: 50vw;
            }

            table {
              border-collapse: collapse;
              border-spacing: 0;
              width: 100%;
              border: 1px solid #ddd;
            }

            th, td {
              text-align: center;
              padding: 16px;
            }

            tr:nth-child(even) {
              background-color: #f2f2f2
            }
          </style>
          <div>
            <p><b>Tipo de desconto aplicado</b>: ${
              this.discountOptions.filter(
                (discount) => discount.value === this.discount.type
              )[0].text
            }</p>
            <table>
              <tr>
                <th>Ciclo</th>
                <th>Preço Orginal</th>
                <th>Desconto</th>
                <th>Preço Descontado</th>
              </tr>
              ${this.modalData()}
            </table>
          </div>`,
      }).then((val) => {
        if (val.value) return true;
        if (val.dismiss) return false;
      });
    },
    getPlanValues() {
      if (!!!this.selected_plan) return 0;

      const plans = [];
      !!this.selected_plan ? plans.push(this.selected_plan) : null;
      !!this.selected_extraPlans ? plans.push(this.selected_extraPlans) : null;

      if (!plans.length > 0) return 0;
      else
        return plans.reduce((acc, plan) => acc + plan.cabecalho.nPrecoUnit, 0);
    },
    printDiscountInfo() {
      const totalValue = this.getPlanValues();
      const discountGrossAmount = !!this.discount.value
        ? this.discount.value
        : 0;

      if (this.discount.type === DISCOUNT_TYPES.FLAT) {
        const finalValue = totalValue - this.discount.value;
        const discountPercentage = (discountGrossAmount / totalValue) * 100;
        return (this.printDiscountString = `Você aplicou um desconto de R$${discountGrossAmount} no valor total do plano. O novo valor do plano é de R$${finalValue.toFixed(
          2
        )}.
          Este desconto equivale a ${discountPercentage.toFixed(
            2
          )}% do valor total do plano.`);
      }

      if (this.discount.type === DISCOUNT_TYPES.PERCENTAGE) {
        const discountValue = totalValue * (this.discount.value / 100);
        const finalValue = totalValue - discountValue;
        const discountedValue = totalValue - finalValue;
        return (this.printDiscountString = `Você aplicou um desconto de ${discountGrossAmount}%. O novo valor do plano é de R$${finalValue.toFixed(
          2
        )}.
          Este desconto equivale a R$${discountedValue.toFixed(
            2
          )} do valor total do plano.`);
      }
    },
    blockInvoiceDiscount() {
      if (!this.isDiscountApplied) return;

      const [, cookieValue] = this.getCookieValue(
        COOKIE_MENAGEMENT.INVALID_DISCOUNT_MODAL.name
      )[0];

      if (this.isPaymentMethodInvoice && this.discount.cycles >= 2) {
        this.discount.cycles = 1;

        if (!JSON.parse(cookieValue)) {
          this.$swal
            .fire({
              title: "Desconto não aplicado",
              html: `
                  <style>
                    .checkbox-wrapper {
                      margin-left: 3vw;
                      gap: 1vw;
                      padding-top: 1vh;
                    }
                    .checkbox-wrapper label {
                        margin-bottom: 0;
                    }
                  </style>
                  <p>
                    Descontos em boletos não podem ser aplicados em mais do que 1 mês através do formulário. Para aplicar descontos em boletos em mais do que 1 mês, aplique diretamente na Omie.
                  </p>
              `,
              input: "checkbox",
              inputPlaceholder: "Não mostrar mais esta mensagem",
              type: "error",
            })
            .then(function (val) {
              if (val.value) {
                document.cookie = `${COOKIE_MENAGEMENT.INVALID_DISCOUNT_MODAL.name}=${COOKIE_MENAGEMENT.INVALID_DISCOUNT_MODAL.value}; expires=${COOKIE_MENAGEMENT.INVALID_DISCOUNT_MODAL.expires};`;
              }
            });
        }
      }
    },
    getCookieValue(cookieName) {
      const data = document.cookie
        .split(";")
        .map((cookie) => cookie.split("="))
        .filter((cookie) => cookie[0].trim() === cookieName);
      return data.length > 0 ? data : [[false, false]];
    },
    handleDiscount() {
      console.log("It went here");
      if (
        !this.isDiscountApplied &&
        !!!this.discount.value &&
        !!!this.discount.type
      )
        return;
      Object.assign(
        this.state.contract,
        { discount: this.discount },
        { isDiscountApplied: this.isDiscountApplied }
      );
    },
    async onSearch() {
      const info = this.cpf_cnpj;

      document.querySelector("#searchButton").disabled = true;

      if (info == "") {
        this.$swal.fire({
          allowOutsideClick: true,
          showConfirmButton: true,
          title: "Oops...",
          text: "Necessário informar o CPF ou CNPJ!",
          type: "error",
          onClose: () => {
            window.location.reload();
          },
        });
        return;
      }

      if (this.isSwalClosed) {
        this.$swal.fire({
          showConfirmButton: false,
          allowOutsideClick: true,
          title: "Aguarde...",
          html: `
            ${this.style}
            Buscando débitos...
            <br>
            <br>
            <div id="loading"></div>
          `,
        });
      }

      const { data } = await verifyContract(info).catch((err) => {
        this.$swal.close();
        this.$swal.fire({
          allowOutsideClick: true,
          showConfirmButton: true,
          title: "Cliente não encontrado!",
          text: "Verifique o CPF/CNPJ e tente novamente",
          type: "error",
          onClose: () => {
            window.location.reload();
          },
        });
        return;
      });

      const contracts = data.data.contratoCadastro;
      let index = contracts.filter(function (contract) {
        return contract.cabecalho.cCodSit !== "99";
      });

      if (index.length == 0) {
        this.$swal.close();
        this.$swal.fire({
          allowOutsideClick: true,
          showConfirmButton: true,
          title: "Cliente não possui contrato ativo!",
          type: "error",
          onClose: () => {
            window.location.reload();
          },
        });
        return;
      }

      const { data: register } = await verifyRegister(info);
      this.tradeName = register.data.clientes_cadastro[0].nome_fantasia;

      if (index[0].emailCliente.cEnviarBoleto === "N") {
        this.$swal.close();
        if (index[0].cabecalho.cCodSit === "00") {
          let codInt = index[0].cabecalho.cCodIntCtr;
          const link = `${this.payment_url}/contratacao/${codInt}`;
          this.$swal.fire({
            title: `${this.tradeName}`,
            showConfirmButton: false,
            html: `
            <style>
            .text {
              text-align: center
            }
            .swal-button-custom {
              border-radius: 0px 25px 25px 0px;
            }
            </style>
            <div>
              <p>Valor do plano R$ ${index[0].cabecalho.nValTotMes}</p>
            </div>
            <div class="input-group mb-3">
              <input disabled value="${link}" type="text" class="form-control text border" >
              <div class="input-group-append">
                <button onclick="navigator.clipboard.writeText('${link}')" class="form-control btn btn-secondary swal-button-custom" type="button">Copiar</button>
              </div>
            </div>
            `,
            customClass: "swal-wide",
            onClose: () => {
              window.location.reload();
            },
          });
          return;
        } else {
          this.$swal.fire({
            allowOutsideClick: true,
            showConfirmButton: true,
            title: "Aviso",
            text: "Inscrição já paga ou cancelada!",
            type: "error",
            onClose: () => {
              window.location.reload();
            },
          });
        }
        return;
      }

      if (index[0].emailCliente.cEnviarBoleto === "S") {
        const { data: newInfo } = await verifyEntries(info);
        this.$swal.close();
        if (
          newInfo.data.overdueStatus[0] == undefined &&
          newInfo.data.miscEntries[0] == undefined
        ) {
          this.$swal.fire({
            allowOutsideClick: true,
            showConfirmButton: true,
            title: "Aviso",
            text: "Cliente não possui boletos pendentes!",
            type: "error",
            onClose: () => {
              window.location.reload();
            },
          });
          return;
        }

        let vencVal = this.documents;

        for (let iterator of newInfo.data.overdueStatus) {
          let obj = {
            vencimento: iterator.cabecTitulo.dDtVenc,
            valor: iterator.cabecTitulo.nValorTitulo,
            codigo: iterator.cabecTitulo.nCodTitulo,
          };
          vencVal.push(obj);
        }

        let showModal = document.getElementById("modalTitulos");
        showModal.style.display = "block";

        let modalShadow = document.getElementById("shadow");
        modalShadow.style.display = "block";

        let closeModal = document.getElementsByClassName("close")[0];
        closeModal.onclick = () => {
          ((showModal.style.display = "none"),
          (modalShadow.style.display = "none")),
            window.location.reload();
        };
        window.onclick = (event) => {
          if (event.target == showModal) {
            ((showModal.style.display = "none"),
            (modalShadow.style.display = "none")),
              window.location.reload();
          }
        };
        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            ((showModal.style.display = "none"),
            (modalShadow.style.display = "none")),
              window.location.reload();
          }
        });
      }
      return;
    },
    async searchBill(codigo) {
      if (this.isSwalClosed) {
        this.$swal.fire({
          showConfirmButton: false,
          allowOutsideClick: true,
          title: "Aguarde...",
          html: `
            ${this.style}
            Gerando o boleto...
            <br>
            <br>
            <div id="loading"></div>
          `,
        });
      }

      const { data } = await genInvoice(codigo).catch((err) => {
        this.$swal.fire({
          allowOutsideClick: true,
          showConfirmButton: true,
          title: "Boleto não disponível",
          text: "O título foi modificado ou cancelado!",
          type: "error",
        });
        return;
      });

      let linkTitulo = data.data.cLinkBoleto;
      this.$swal.close();
      window.open(linkTitulo);
    },
  },
  watch: {
    selected_plan(newValue) {
      const plan = newValue.cabecalho.cDescricao.toLowerCase();

      const planType = plan.replace(/\s/g, "").split("-").pop();

      if ((!!planType && planType === "mensal") || plan.includes("mensal"))
        return this.setTipoFat("01");
      if ((!!planType && planType === "anual") || plan.includes("anual"))
        return this.setTipoFat("12");

      this.setTipoFat("01");
      this.tipoFatElement.removeAttribute("readonly");
    },
    diasVencimentoBoleto(newValue) {
      this.state.contract.vencTextos.nDias = +newValue;
    },
    "discount.value": async function (newValue) {
      const totalValue = await this.getPlanValues();

      if (this.discount.type === DISCOUNT_TYPES.PERCENTAGE && newValue > 100)
        this.discount.value = 100;
      if (this.discount.type === DISCOUNT_TYPES.PERCENTAGE && newValue < 0)
        this.discount.value = 0;
      if (this.discount.type === DISCOUNT_TYPES.FLAT && newValue < 0)
        this.discount.value = 0;
      if (this.discount.type === DISCOUNT_TYPES.FLAT && newValue > totalValue)
        this.discount.value = totalValue;
    },
    "discount.type": function (newValue) {
      this.printDiscountInfo();
    },
    discountAllCycles(newValue) {
      if (!newValue) return false;
      this.discount.cycles = 360;
    },
    "state.contract.cabecalho.cTipoFat": function (newValue) {
      if (newValue === "12")
        return this.state.client.tags.push({ tag: "Anual" });
      else
        this.state.client.tags = this.state.client.tags.filter(
          (tag) => tag.tag !== "Anual"
        );
    },
  },
  mounted() {
    this.state.client.codigo_cliente_integracao = uuidv4().substring(0, 13);
    this.integrationCode = this.state.client.codigo_cliente_integracao;

    console.log(
      `%cINTEGRATION CODE ${this.integrationCode}`,
      "font-size: 10px; color: red;"
    );

    this.tipoFatElement = document.querySelector(".tipo-fat");

    this.fetchPlan();
    this.fetchSellers();
    this.wss = io.connect(this.socket_url, {
      transports: ["websocket"],
      query: {
        type: "admin",
      },
    });
    this.wss.on("connect", () => {
      console.log("connected");
    });

    this.wss.on("disconnect", (err) => {
      console.log("disconnected", err);
    });

    this.wss.on("connect_error", (err) => {
      console.log("connect_error", err);
    });
  },
};
